import { PageHeader } from '../../components/PageHeader/PageHeader'
import { DetailEntityFields } from '../../components/DetailEntityFields/DetailEntityFields'
import { PageLoadingShell } from '../PageLoadingShell/PageLoadingShell'
import type { DetailEntityPageProps } from './DetailEntityPage.types'

export function DetailEntityPage({
  title,
  loadingLabel,
  note,
  fields,
  isLoading,
  error,
  actions,
}: DetailEntityPageProps) {
  return (
    <PageLoadingShell
      loadingLabel={loadingLabel}
      isLoading={isLoading}
      error={error}
    >
      <PageHeader title={title} actions={actions} />
      <section className="content-card content-card--padded" aria-label={title}>
        {note && (
          <div className="alert alert-info" role="note">
            {note}
          </div>
        )}
        <DetailEntityFields fields={fields} />
      </section>
    </PageLoadingShell>
  )
}
